export default "__VITE_ASSET__ylDO50QP__"